import { Box, useMantineTheme } from '@mantine/core';
import { forwardRef, useState } from 'react';
import { useReducedMotion } from '../hooks';

export interface HoverGlowProps {
  children: React.ReactNode;
  color?: string;
  gradientVariant?: 'primary' | 'secondary' | 'tertiary';
  intensity?: number;
  spread?: number;
  duration?: number;
}

const HoverGlow = forwardRef<HTMLDivElement, HoverGlowProps>(
  (
    {
      children,
      color,
      gradientVariant = 'primary',
      intensity = 0.4,
      spread = 20,
      duration = 200,
    },
    ref
  ) => {
    const theme = useMantineTheme();
    const reducedMotion = useReducedMotion();
    const [isHovered, setIsHovered] = useState(false);

    const gradient = theme.other?.gradients?.[gradientVariant];
    const glowColor = color || gradient?.from || theme.primaryColor;

    return (
      <Box
        ref={ref}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          boxShadow: isHovered && !reducedMotion
            ? `0 0 ${spread}px ${spread / 2}px ${glowColor}${Math.round(intensity * 255).toString(16).padStart(2, '0')}`
            : '0 0 0 0 transparent',
          transition: reducedMotion ? 'none' : `box-shadow ${duration}ms ease-out`,
        }}
      >
        {children}
      </Box>
    );
  }
);

HoverGlow.displayName = 'HoverGlow';

export default HoverGlow;
